// import { cloneDeep } from 'lodash';

// const initialState = {
//   authenticated: false,
//   user: {
//     userId: null,
//     alias: null,
//     role: null,
//     placeId: null,
//   },
//   placeId: 'friendspub',
//   loading: false,
// };

const logout = (state, payload) => {
  const newState = {
    authenticated: false,
    user: {
      userId: null,
      alias: null,
      role: null,
      placeId: null,
    },
    loading: false,
  };
  
  return newState;
};

export { logout };
